import * as Yup from 'yup';

export const AddProductValidationSchema = Yup.object().shape({
    name: Yup.string().min(1, 'Too Short!').nullable().required('Required'),
    price: Yup.string().nullable().required('Required'),
    quantityInStock: Yup.string().nullable().required('Required'),
    stockQuantityThreshold: Yup.string().nullable().required('Required'),
});
